(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('OriginatorAppraiserDirectNoteDialogController', OriginatorAppraiserDirectNoteDialogController);

    OriginatorAppraiserDirectNoteDialogController.$inject = ['$scope', '$mdDialog', 'entity', 'OriginatorAppraiserDirectNote'];

    function OriginatorAppraiserDirectNoteDialogController ($scope, $mdDialog, entity, OriginatorAppraiserDirectNote) {
        var vm = this;

        vm.note = entity;

        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $mdDialog.cancel('cancel');
        }

        function save () {
            vm.isSaving = true;
            OriginatorAppraiserDirectNote.save(vm.note, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $mdDialog.hide(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();
